import Animation from "./intro/_animation.es6";

const animation = new Animation();